import React from 'react';

interface Props {
  status: string | null | undefined;
}

const classesFor = (status: string) => {
  const normalized = status.toLowerCase();
  if (normalized.includes('fail') || normalized.includes('error')) return 'bg-strivre-lightburgundy text-strivre-burgundy border-strivre-burgundy/20';
  if (normalized.includes('success') || normalized.includes('synced')) return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  if (normalized.includes('pending') || normalized.includes('progress')) return 'bg-amber-50 text-amber-700 border-amber-200';
  return 'bg-strivre-softgrey text-slate-500 border-strivre-lightnavy';
};

// Renders the free-text calendarSyncStatus / crmSyncStatus values returned on a booking.
export default function SyncStatusBadge({ status }: Props) {
  const label = status && status.trim() ? status : 'Not Synced';
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded text-xs font-semibold border ${classesFor(label)}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}

